import {
  ActionType,
  AutoTextField,
  BooleanField,
  SelectField,
} from '../../../components/AutoForm/AutoFieldNew';
import {moneyFieldValueType} from '../../../components/AutoForm/AutoFormNew';
import {
  builderFieldsType,
  DAFeeFieldType,
  initialFeesFieldType,
} from '../CreateBuilder/builderFields';
import {
  AnnuityIncomeFrequencyEnum,
  AnnuityPaymentTypeEnum,
  AnnuityRateTypeEnum,
  AnnuityTypeEnum,
} from '../../../schema-types/globalTypes';

export type setUpAnnuityFields = {
  sourceId?: string;
  parentPotId?: string;
  annuityType?: AnnuityTypeEnum;
  incomeFrequency?: AnnuityIncomeFrequencyEnum;
  guaranteePeriod?: number;
  spouseAnnuityPercent?: number;
  rateType?: AnnuityRateTypeEnum;
  indexLinked?: boolean;
  longTermCareCapitalProtected?: boolean;
  ltcProtectedPercent?: number;
  initialFee?: initialFeesFieldType;
  notes?: string;
  paymentType?: AnnuityPaymentTypeEnum;
  singleClientAmount?: moneyFieldValueType;
  full?: boolean;
  legacyInitialFee?: DAFeeFieldType | null;
};

export const annuityTypeField: SelectField<builderFieldsType> = {
  id: 'annuity.annuityType',
  label: 'Annuity Type',
  type: ActionType.select,
  options: [
    {
      label: 'Personal Pension Annuity',
      value: AnnuityTypeEnum.PERSONAL_PENSION_ANNUITY,
    },
    {
      label: 'Fixed Term Annuity',
      value: AnnuityTypeEnum.FIXED_TERM_ANNUITY,
    },
    {
      label: 'Long Term Care (Prefunded)',
      value: AnnuityTypeEnum.LONG_TERM_CARE_PREFUNDED,
    },
  ],
  validation: (val) => {
    if (val === 'undefined' || !val) {
      return 'Please choose a value';
    }
    return undefined;
  },
};

export const annuityIncomeFrequencyField: SelectField<builderFieldsType> = {
  id: 'annuity.incomeFrequency',
  label: 'Income Frequency',
  type: ActionType.select,
  options: [
    {
      label: 'Monthly',
      value: AnnuityIncomeFrequencyEnum.MONTHLY,
    },
    {
      label: 'Weekly',
      value: AnnuityIncomeFrequencyEnum.WEEKLY,
    },
    {
      label: 'Quarterly',
      value: AnnuityIncomeFrequencyEnum.QUARTERLY,
    },
    {
      label: 'Bi-annually',
      value: AnnuityIncomeFrequencyEnum.BI_ANNUALLY,
    },
    {
      label: 'Annually',
      value: AnnuityIncomeFrequencyEnum.ANNUALLY,
    },
  ],
};

export const annuityGuaranteePeriodField: AutoTextField<builderFieldsType> = {
  id: 'annuity.guaranteePeriod',
  label: 'Guarantee Period (Yrs)',
  type: ActionType.text,
  initialValue: '',
  number: true,
  validation: (val) => {
    if (Number.isNaN(val) || val === 'undefined' || !val) {
      return 'Value must be a number';
    }
    if (Number(val) < 0) {
      return 'Value must be a positive number';
    }
    if (Number(val) > 99) {
      return 'Value must be up to 99';
    }
    return undefined;
  },
};

export const annuitySpousePercentField: AutoTextField<builderFieldsType> = {
  id: 'annuity.spouseAnnuityPercent',
  label: "Spouse's Annuity %",
  type: ActionType.text,
  initialValue: '',
  percent: true,
  decimals: 1,
  validation: (val) => {
    if (Number.isNaN(val) || val === 'undefined' || !val) {
      return 'Value must be a number';
    }
    if (Number(val) < 0) {
      return 'Value must be a positive number';
    }
    if (Number(val) > 100) {
      return 'Value must be up to 100';
    }
    return undefined;
  },
};

export const annuityRateTypeField: SelectField<builderFieldsType> = {
  id: 'annuity.rateType',
  label: 'Rate Type',
  type: ActionType.select,
  options: [
    {
      label: 'Ordinary rates',
      value: AnnuityRateTypeEnum.ORDINARY_RATES,
    },
    {
      label: 'Impaired life',
      value: AnnuityRateTypeEnum.IMPAIRED_LIFE,
    },
  ],
};

export const annuityIndexLinkedField: BooleanField<builderFieldsType> = {
  id: 'annuity.indexLinked',
  label: 'Index Linked',
  type: ActionType.boolean,
  yesValue: true,
  noValue: false,
  labelNotClickable: true,
  initialValue: false,
};

export const annuityLongTermCareField: BooleanField<builderFieldsType> = {
  id: 'annuity.longTermCareCapitalProtected',
  label: 'Long Term Care Capital Protected',
  type: ActionType.boolean,
  yesValue: true,
  noValue: false,
  labelNotClickable: true,
  initialValue: false,
};

export const annuityLtcProtectedPercentField: AutoTextField<builderFieldsType> = {
  id: 'annuity.ltcProtectedPercent',
  label: 'LTC Protected %',
  type: ActionType.text,
  initialValue: '',
  percent: true,
  decimals: 1,
  validation: (val) => {
    if (Number.isNaN(val) || val === 'undefined' || !val) {
      return 'Value must be a number';
    }
    if (Number(val) < 0) {
      return 'Value must be a positive number';
    }
    if (Number(val) > 100) {
      return 'Value must be up to 100';
    }
    return undefined;
  },
};

export const annuityPaymentTypeField: SelectField<builderFieldsType> = {
  id: 'annuity.paymentType',
  label: 'Payment Type',
  type: ActionType.select,
  options: [
    {
      label: 'In arrears',
      value: AnnuityPaymentTypeEnum.IN_ARREARS,
    },
    {
      label: 'In advance',
      value: AnnuityPaymentTypeEnum.IN_ADVANCE,
    },
  ],
};

export const annuityNotesField: AutoTextField<builderFieldsType> = {
  id: 'annuity.notes',
  label: 'Notes',
  type: ActionType.text,
  initialValue: '',
  multiline: true,
  minRows: 10,
};
